import SkillsList from "../SkillsList";
import LanguageOverview, { LanguageOverviewProps } from "../LanguageOverview";
import useTranslations from "@/i18n/useTranslations";

export interface SkillLanguageOverviewProps extends LanguageOverviewProps {
  associatedSkills?: string[];
}

export default function SkillLanguageOverview({
  associatedSkills,
  prerequisitesHtml = "",
  syllabusHtml,
  formattedLanguage,
  formattedTranscripts = [],
  formattedAiLanguages = [],
  learningItems,
  oneColumn = false,
  isCurriculumInMainContent = false,
}: SkillLanguageOverviewProps) {
  const t = useTranslations("Course");
  return (
    <>
      {associatedSkills && (
        <div className="flex flex-col">
          <SkillsList
            associatedSkills={associatedSkills}
            title={t("growTheseSkills")}
            theme="light"
          />
        </div>
      )}
      <LanguageOverview
        prerequisitesHtml={prerequisitesHtml}
        syllabusHtml={syllabusHtml}
        formattedLanguage={formattedLanguage}
        formattedTranscripts={formattedTranscripts}
        formattedAiLanguages={formattedAiLanguages}
        learningItems={learningItems}
        oneColumn={oneColumn}
        isCurriculumInMainContent={isCurriculumInMainContent}
      />
    </>
  );
}
